<ion-toolbar class="header-content">
  <div class="back-button-container">

    <ion-button (click)="onBackClick()" fill="clear" shape="round" class="back-button">
      <i class="fas fa-arrow-circle-left icon"></i>
    </ion-button>

    <div class="delivery-info" *ngIf="delivery">
      <label title="{{delivery?.artistName}}"
        class="label ellipsis artist-label">
        {{delivery?.artistName}}
      </label>
      <label title="{{delivery?.distributionName}}"
        class="label ellipsis">
        {{delivery?.distributionName}}
      </label>
    </div>
  </div>

  <ion-buttons slot="end">
    <div *ngIf="isDevicePlatform" class="button-container fadeInRight delay-0s2">
      <div *ngIf="asset$ | async as asset" class="play-title">
        <span class="title ellipsis">{{asset?.title}} – {{delivery?.artistName}}</span>
        <ion-button
          (click)="togglePlay(!asset.isPlaying)"
          shape="round"
          color="light"
          class="nav-button">
          <i *ngIf="!asset.isPlaying" class="fas fa-play icon"></i>
          <i *ngIf="asset.isPlaying" class="fas fa-pause icon"></i>
        </ion-button>
      </div>
    </div>

    <div *ngFor="let button of getButtons(); let i= index"
      class="button-container fadeInRight delay-0s{{i + 3}}">
      <ion-button
        *ngIf="button.id !== 'favorite' && button.id !== 'offline'"
        shape="round"
        color="light"
        (click)="onMenuButtonClick(button?.id, delivery)"
        [ngClass]="{'nav-active': delivery[button?.id] || isBtnActive(button.id)}"
        class="nav-button {{button?.class}}">
        <i class="fas icon" [ngClass]="button?.icon"></i>
      </ion-button>
      <pptl-favorite-btn
        *ngIf="button.id === 'favorite'"
        [delivery]='delivery'></pptl-favorite-btn>
      <pptl-download-btn
        *ngIf="isDwnlBtnShowen(button)"
        [downloadConf]="downloadConfig$ |async"
        [delivery]='delivery'></pptl-download-btn>
    </div>
  </ion-buttons>


</ion-toolbar>
